export var LanguageCustomizationForm;
(function (LanguageCustomizationForm) {
    let Fields;
    (function (Fields) {
        Fields["lookAndFeel"] = "look_and_feel";
        Fields["ratingQuestion"] = "rating_question";
        Fields["followupQuestion"] = "rating_follow_up_question";
        Fields["ratingPlaceholder"] = "rating_placeholder_text";
        Fields["thankyouMessage"] = "rating_completed_message";
    })(Fields = LanguageCustomizationForm.Fields || (LanguageCustomizationForm.Fields = {}));
})(LanguageCustomizationForm || (LanguageCustomizationForm = {}));
